<template>
  <div class="container">
    <Header @toSearch="toSearch"></Header>
    <div class="dWrap">
      <div class="content">
        <div class="newsTabs">
          <div class="name">
            <span
              >关键词：<em>{{ keyword }}</em></span
            >
          </div>

          <div class="searchList">
            <div class="newsList">
              <template v-if="newsList && newsList.length > 0">
                <div
                  class="item"
                  :class="{ isHot: item.isHot && item.isHot!=='0' }"
                  v-for="(item, key) in newsList"
                  @click="openLink(item.id)"
                  :key="key"
                >
                  <span>
                    {{ item.title }}
                  </span>
                  <em>{{ item.publishTime?item.publishTime:item.createTime }}</em>
                </div>
              </template>
              <img src="@img/empty.png" v-if="!newsList || newsList.length === 0" alt="" class="empty" />
            </div>
          </div>
          <div class="list-page">
            <el-pagination
              layout="prev, pager,sizes, next"
              :current-page="page.current"
              @size-change="handleSizeChange"
              @current-change="currentChange"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      total: 0,
      keyword: '',
      page: {
        size: 10,
        total: 0,
        current: 1
      },
      newsList: []
    };
  },
  mounted() {
    this.keyword = this.$route.params.keyword;
    this.getList();
  },
  methods: {
    getList() {
      this.$api(
        this.$config.apiUrl.search,
        {
          keyWord: this.keyword,
          size: this.page.size,
          current: this.page.current
        },
        { method: 'get' }
      )
        .then(data => {
          data.records.forEach(item => {
            item.createTime = moment(item.createTime).format('YYYY-MM-DD');
            if(item.publishTime) {
              item.publishTime = moment(item.publishTime).format('YYYY-MM-DD');
            }
          });
          this.page.total = data.total;
          this.page.current = data.current;
          this.newsList = data.records;
        })
        .catch(() => {
          console.log('获取搜索结果失败');
        });
    },
    currentChange(val) {
      this.page.current = val;
      this.getList();
    },
    toSearch(val) {
      this.keyword = val;
      this.page.total = 0;
      this.page.current = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    openLink(id) {
      let routeData = this.$router.resolve({
        name: 'Detail',
        params: { id: id }
      });
      window.open(routeData.href, '_blank');
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .dWrap {
    width: 1124px;
    padding: 0 14px;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
  }
  .content {
    padding: 30px 0 0px;
    .newsTabs {
      position: relative;
      padding: 0 18px;
      margin-bottom: 18px;
      min-height: 290px;
    }
  }

  .name {
    position: relative;
    border-bottom: 2px solid #013f99;
    span {
      display: inline-block;
      position: relative;
      height: 40px;
      font-size: 18px;
      color: #000;
      line-height: 40px;
      em {
        font-weight: 600;
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -1px;
        width: 100%;
        height: 2px;
        background-color: #013f99;
        z-index: 1;
      }
    }
  }

  .searchList {
    margin-top: 15px;
  }

  .newsList {
    position: relative;
    min-height: 309px;
    .empty {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: auto;
      height: auto;
      margin: auto;
    }

    .item {
      position: relative;
      padding-right: 120px;
      padding-left: 16px;
      line-height: 30px;
      font-size: 14px;
      color: #5e5a5a;
      cursor: pointer;
      border-bottom: 1px solid #e0e0e0;
      &.isHot {
        padding-left: 52px !important;
        background-position: 16px center;
      }
      &:last-child {
        border-bottom: 0;
      }
      &::before {
        position: absolute;
        content: '';
        left: 0;
        top: 50%;
        width: 8px;
        height: 8px;
        margin-top: -4px;
        background: #000000;
      }
      &:hover {
        color: #999;
      }
      span {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      em {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  /* .list-page {
    padding: 10px 0 10px 0;
    /deep/.el-pager li {
      position: relative;
      overflow: hidden;
      padding: 0 8px;
      min-width: 10px;
      &:before {
        position: absolute;
        content: '[';
        left: 2px;
        top: 50%;
        line-height: 26px;
        margin-top: -14px;
      }
      &:after {
        position: absolute;
        content: ']';
        right: 2px;
        top: 50%;
        line-height: 26px;
        margin-top: -14px;
      }
    }
  } */
}
</style>
